<template>
  <v-container fluid>
    <v-card class="elevation-1 mb-6">
      <v-card-title class="pa-7">
        Přehled administrátorů
        <v-spacer></v-spacer>

        <v-btn
          color="primary"
          height="40px"
          min-width="130px"
          depressed
          :to="{ name: 'administrators.add' }"
        >
          Nový administrátor
        </v-btn>
      </v-card-title>
      <v-card-text>
        <AdministratorsFilters @filter="setFiltersAction" />

        <v-data-table
          :headers="userHeadersByRole"
          :items="user.items"
          :options.sync="user.options"
          :server-items-length="user.serverItemsLength"
          :loading="user.loading"
          item-key="id"
          class="elevation-0"
        >
          <template v-slot:item.id="{ item }">
            <router-link
              :to="{
                name: 'administrators.detail',
                params: {
                  id: item.id,
                },
              }"
            >
              {{ item.id }}
            </router-link>
          </template>
          <template v-slot:item.createdAt="{ item }">
            <DateTime :datetime="item.createdAt" :single-line="false" />
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn-toggle color="primary" dense group>
              <v-btn
                :to="{ name: 'administrators.edit', params: { id: item.id } }"
                color="blue-grey"
                text
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import AdministratorsFilters from '@/components/filters/AdministratorsFilters.vue'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'

export default {
  name: 'Administrators',
  components: {
    DateTime,
    AdministratorsFilters,
  },
  mixins: [setFilters],
  data() {
    return {
      user: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
            width: '150px',
          },
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
            width: '100px',
          },
          {
            text: 'E-mail',
            value: 'email',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 10,
          sortBy: ['id'],
          sortDesc: [false],
        },
        loading: false,
        serverItemsLength: 0,
      },
      userFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    userHeadersByRole() {
      return this.user.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    'user.options': {
      handler() {
        this.loadAdministrators()
      },
    },
    '$route.query': {
      handler() {
        this.loadAdministrators()
      },
    },
  },
  methods: {
    ...mapActions({
      searchUsers: 'user/searchUsers',
    }),
    loadAdministrators() {
      this.user.loading = true
      const searchParams = {
        filterParams: this.$route.query,
        options: this.user.options,
      }
      this.searchUsers({ params: searchParams, roles: ['ADMIN'] })
        .then((response) => {
          this.userFooter.totalElements = response.data.totalElements
          this.user.items = response.data.items
          this.user.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.user.loading = false
        })
    },
    setFiltersAction(filters) {
      this.user.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
